import { AlertTriangle, LogOut } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useMe } from '@/hooks/useAuth';
import { useReturnToAdmin } from '@/hooks/useImpersonation';
import { useAlert } from '@/components/ConfirmDialog';

export function ImpersonationBanner() {
  const me = useMe();
  const ret = useReturnToAdmin();
  const alertDialog = useAlert();

  const imp = me.data?.impersonator;
  if (!imp) return null;

  const onReturn = async () => {
    try {
      await ret.mutateAsync();
      // Hard reload — identity just changed. This wipes every React
      // state / query subscription that could still read the old user,
      // and avoids racing the /me refetch while routes re-mount.
      window.location.href = '/platform/users';
    } catch (err) {
      await alertDialog({
        title: 'Admine dönülemedi',
        description: err instanceof Error ? err.message : 'Beklenmedik hata',
        danger: true,
      });
    }
  };

  return (
    <div
      role="alert"
      aria-live="polite"
      className="bg-amber-500/25 dark:bg-amber-500/15 border-b border-amber-500/40 text-amber-900 dark:text-amber-100 text-sm"
    >
      <div className="px-4 py-2 flex items-center gap-3 flex-wrap">
        <AlertTriangle className="w-4 h-4 text-amber-700 dark:text-amber-400 shrink-0" />
        <div className="flex-1 min-w-0">
          <span className="font-medium">
            {me.data?.user.full_name ?? me.data?.user.email}
          </span>
          <span className="text-amber-900/80 dark:text-amber-100/80"> olarak giriştesin</span>
          <span className="text-xs text-amber-900/70 dark:text-amber-100/70 ml-2">
            (admin: {imp.admin_email})
          </span>
        </div>
        <Button size="sm" variant="outline" onClick={onReturn} disabled={ret.isPending}>
          <LogOut className="w-3.5 h-3.5" /> Admine Dön
        </Button>
      </div>
    </div>
  );
}
